module.exports = __webpack_public_path__ + "entry-150bfe9b/ikea-photo-2d48d21946163d9f27625ea4a7a8a1ce.webp";